import React, { useEffect, useState, useRef, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import InputMask from "react-input-mask";
import { URLBunge } from "../../../Componentes/Config";
import {
  AlertForm,
  AlertRedirect,
  MascaraCNPJ,
} from "../../../Componentes/Funcoes";
import CabecalhoPagina from "../../../Componentes/Cabecalho";
import Carregando from "../../../Componentes/Carregando";
import MenuPrinc from "../../../Componentes/MenuPrinc";

import {
  Clear,
  BackgroundImg,
  TitNoticias,
  ColunaRegras,
  BtVoltar,
  CampoFormCadastro,
  FormPesquisa,
  DescCampo,
  BotaoEnviarPesquisa,
  EndLinha04,
  SolicitanteCliente,
  ItemListaAtendimentos,
  TipoAtendimento,
} from "../../../Estilos";

import ImgBtSetaVoltar from "../../../Images/BtSeta.png";

function EditarRequisicao(props) {
  const history = useHistory();
  const location = useLocation();
  const [Loading, setLoading] = useState(false);
  const { register, handleSubmit, errors, control, setValue } = useForm();
  const [nomeTecnico, setNomeTecnico] = useState("");
  const [c_tecnico, setc_tecnico] = useState(0);
  const [ListaTecnicos, setListaTecnicos] = useState([]);
  const [NomeEvento, setNomeEvento] = useState("Minha Bunge Vendas");
  const [Token, setToken] = useState(localStorage.getItem("c_token"));
  const [IdUser, setIdUser] = useState(localStorage.getItem("id_tb_user"));
  const [CPFUser, setCPFUser] = useState(localStorage.getItem("c_cpf"));
  const [TextoAguarde, setTextoAguarde] = useState(false);

  console.log("######", location.state.item);

  var idRequisicao = location.state.item.idRequisicao;
  var solicitante = location.state.item.solicitante;
  var cliente = location.state.item.cliente;
  var tipoAtendimento = location.state.item.tipoAtendimento;
  var detalhes = location.state.item.detalhes;
  var produto = location.state.item.produto;
  var tecnico = location.state.item.nomeTecnico;
  var telCliente = location.state.item.telefoneCliente;
  var telVendedor = location.state.item.telefoneVendedor;
  var diaSemana = location.state.item.diaSemanaDescricao;
  var duracaoTreino = location.state.item.duracaoTreinamento;
  var dia = location.state.item.dataVisita.substr(8, 2);
  var mes = location.state.item.dataVisita.substr(5, 2);
  var ano = location.state.item.dataVisita.substr(0, 4);
  var hor = location.state.item.dataVisita.substr(11, 2);
  var min = location.state.item.dataVisita.substr(14, 2);

  var dataVisita = dia + "/" + mes + "/" + ano + " - " + hor + ":" + min;

  // var potencialCompra = (location.state.item.potencialCompra).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  var potencialCompra = location.state.item.potencialCompra + " KG";
  var cnpj = location.state.item.cnpj;
  var sap = location.state.item.sap;
  var rua = location.state.item.rua;
  var numero = location.state.item.numero;
  var cep = location.state.item.cep;
  var bairro = location.state.item.bairro;
  var cidade = location.state.item.cidade;
  var uf = location.state.item.uf;

  function PegaTecnicos() {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${URLBunge}/api/Requisicoes/ListarTecnicos`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result);

        for (let i = 0; i < result.listaTecnicos.length; i = i + 1) {
          setListaTecnicos((ListaTecnicos) => [
            ...ListaTecnicos,
            {
              value: result.listaTecnicos[i].id,
              label: result.listaTecnicos[i].nome,
            },
          ]);
        }
      })
      .catch((error) => console.log("error", error));
  }
  useEffect(() => {
    PegaTecnicos();
  }, []);

  function ValidaData(input) {
    var VerificaData =
      /(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d/;
    if (input.match(VerificaData)) {
      return true;
    } else {
      return false;
    }
  }

  const EnviarFormulario = async (data, e) => {
    if (data.c_data == null || data.c_data == "") {
      AlertForm("Data é um campo obrigatório.");
      e.preventDefault();
      return false;
    }

    if (!ValidaData(data.c_data)) {
      AlertForm("Verifique a data");
      e.preventDefault();
      return false;
    }

    if (data.c_hora == null || data.c_hora == "") {
      AlertForm("Hora é um campo obrigatório.");
      e.preventDefault();
      return false;
    }

    if (data.c_tecnico == 0) {
      AlertForm("Você precisa selecionar um técnico");
      e.preventDefault();
      return false;
    }

    console.log("data", data);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      requisicaoId: idRequisicao,
      tecnicoId: data.c_tecnico,
      dataVisita:
        data.c_data.substr(6, 12) +
        "-" +
        data.c_data.substr(3, 2) +
        "-" +
        data.c_data.substr(0, 2) +
        "T" +
        data.c_hora.substr(0, 2) +
        ":" +
        data.c_hora.substr(3, 2) +
        ":00.000Z",
      nomeTecnico: nomeTecnico,
    });

    console.log(raw);
    setTextoAguarde(true);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${URLBunge}/api/Requisicoes/EditarRequisicoes`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result);

        if (result.sucesso === true) {
          setTextoAguarde(false);
          AlertRedirect(
            "Requisição atualizada com sucesso!",
            "AcademiaFormularioRequisicoes",
            history
          );
        } else {
          setTextoAguarde(false);
          AlertForm(result.mensagem);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setTextoAguarde(false);
      });
  };

  const SelecionaTecnico = async (value) => {
    var NomeTecnico = ListaTecnicos.filter(function (arr) {
      return arr.value == value;
    });
    setNomeTecnico(NomeTecnico[0].label);
    setc_tecnico(value);
  };

  return (
    <>
      <CabecalhoPagina NomeEvento={NomeEvento} />
      {Loading === true ? <Carregando /> : null}

      <BackgroundImg Background={""} BackgroundMob={""} bgcolor={"#FFFFFF"}>
        <ColunaRegras>
          <div className={"AreaColunaRegras"}>
            <TitNoticias>Editar Requisição</TitNoticias>
            <Clear />

            <BtVoltar
              onClick={() =>
                history.push({
                  pathname: "/AcademiaFormularioRequisicoes",
                  state: {},
                })
              }
              style={{ marginLeft: "auto", marginRight: "auto" }}
            >
              <img src={ImgBtSetaVoltar} /> <div>VOLTAR</div>
            </BtVoltar>

            <FormPesquisa onSubmit={handleSubmit(EnviarFormulario)}>
              <ItemListaAtendimentos>
                <SolicitanteCliente>
                  {" "}
                  Solicitante: <div>{solicitante}</div>{" "}
                </SolicitanteCliente>
                <SolicitanteCliente>
                  {" "}
                  Técnico: <div>{tecnico}</div>{" "}
                </SolicitanteCliente>
                <TipoAtendimento>
                  {" "}
                  Qual tipo de atendimento?{" "}
                  <div>
                    {tipoAtendimento}
                    <br />
                    {detalhes}
                  </div>{" "}
                </TipoAtendimento>
                <SolicitanteCliente>
                  Qual o cliente? <div>{cliente}</div>
                  CNPJ: {MascaraCNPJ(cnpj)}
                  <br />
                  SAP: {sap}
                  <br />
                  Endereço: {rua}, {numero}
                  <br />
                  {bairro}, {cidade}, {uf}
                  <br />
                  {cep}
                </SolicitanteCliente>
                <SolicitanteCliente>
                  {" "}
                  Telefone do Vendedor: <div>{telVendedor}</div>{" "}
                </SolicitanteCliente>
                <SolicitanteCliente>
                  {" "}
                  Telefone do Cliente: <div>{telCliente}</div>{" "}
                </SolicitanteCliente>

                <SolicitanteCliente>
                  {" "}
                  Qual a data que o cliente deseja a visita?{" "}
                  <div>{dataVisita}</div>{" "}
                </SolicitanteCliente>
                <SolicitanteCliente>
                  {" "}
                  Qual o melhor dia da semana para a visita?{" "}
                  <div>{diaSemana}</div>{" "}
                </SolicitanteCliente>
                <SolicitanteCliente>
                  {" "}
                  Quantos dias vai durar o treinamento?{" "}
                  <div>{duracaoTreino}</div>{" "}
                </SolicitanteCliente>
                <SolicitanteCliente>
                  {" "}
                  Qual o potencial de compra/mês do cliente? (Tonelada){" "}
                  <div>{potencialCompra}</div>{" "}
                </SolicitanteCliente>
              </ItemListaAtendimentos>

              <DescCampo>Qual a data da visita?</DescCampo>
              <EndLinha04>
                <CampoFormCadastro>
                  <Controller
                    control={control}
                    ref={register}
                    id="c_data"
                    name="c_data"
                    type="text"
                    placeholder={"Data"}
                    className="CampoForm CampoFormLogin"
                    as={InputMask}
                    mask="99/99/9999"
                  />
                </CampoFormCadastro>

                <CampoFormCadastro>
                  <Controller
                    control={control}
                    ref={register}
                    id="c_hora"
                    name="c_hora"
                    type="text"
                    placeholder={"Hora"}
                    className="CampoForm CampoFormLogin"
                    as={InputMask}
                    mask={"99:99"}
                  />
                </CampoFormCadastro>
              </EndLinha04>

              <CampoFormCadastro>
                <select name={"c_tecnico"} id={"c_tecnico"} ref={register}>
                  <option value={0} disabled selected>
                    Selecione o técnico
                  </option>
                  {ListaTecnicos.map((item, index) => {
                    return (
                      <>
                        {" "}
                        <option value={item.value}>{item.label}</option>{" "}
                      </>
                    );
                  })}
                </select>
              </CampoFormCadastro>

              <br />

              <Clear />
              {TextoAguarde === false ? (
                <BotaoEnviarPesquisa type="submit">
                  EDITAR REQUISICÃO
                </BotaoEnviarPesquisa>
              ) : (
                <BotaoEnviarPesquisa disabled>AGUARDE...</BotaoEnviarPesquisa>
              )}

              <Clear />
            </FormPesquisa>
          </div>
        </ColunaRegras>

        <MenuPrinc Pagina="Pesquisas" />
      </BackgroundImg>
    </>
  );
}

export default EditarRequisicao;
